import * as React from 'react'
import { api } from '../../../../util/api'

export const useAiResponseStream = () => {
  const [aiResponse, setAiResponse] = React.useState('')
  const [coverLetterId, setCoverLetterId] = React.useState(null)
  const [aiStreamComplete, setAiStreamComplete] = React.useState(false)
  const [serverSentEvents, setServerSentEvents] = React.useState(false)

  React.useEffect(() => {
    if (!serverSentEvents) return
    if (!coverLetterId) return

    const eventURL = `/personal_brand/cover_letters/create_ai_sse/${coverLetterId}?format=json`
    const eventSource = new EventSource(eventURL)

    eventSource.addEventListener('message', (event) => {
      setAiResponse((r) => `${r}${event.data}`)
    })

    eventSource.addEventListener('error', (event) => {
      if (event.eventPhase === EventSource.CLOSED) {
        eventSource.close()
        setAiStreamComplete(true)
      }
    })

    return () => eventSource.close()
  }, [coverLetterId, serverSentEvents])

  React.useEffect(() => {
    if (serverSentEvents) return
    if (!coverLetterId) return

    const pollingURL = `/personal_brand/cover_letters/create_ai_polling/${coverLetterId}`

    const interval = setInterval(async () => {
      const {
        data: { content, completed },
      } = await api.get(pollingURL)
      setAiResponse(`${content}`)
      setAiStreamComplete(completed)
      const copyButton = document.getElementById('copy-button')
      const downloadButton = document.getElementById(
        'download-button-container',
      )
      const aylaCoverLetterText = document.getElementById(
        'ayla-cover-letter-text',
      )
      const coverLetterButtons = document.getElementById('cover-letter-buttons')
      const continueButton = document.getElementById('continue-button')
      if (
        completed &&
        copyButton &&
        downloadButton &&
        aylaCoverLetterText &&
        coverLetterButtons &&
        continueButton
      ) {
        copyButton.style.display = 'flex'
        downloadButton.style.display = 'block'
        aylaCoverLetterText.style.display = 'block'
        coverLetterButtons.style.display = 'flex'
        continueButton.style.display = 'block'
        clearInterval(interval)
        setAiResponse('')
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [coverLetterId, aiResponse, aiStreamComplete, serverSentEvents])

  return {
    aiResponse,
    coverLetterId,
    setCoverLetterId,
    aiStreamComplete,
    setServerSentEvents,
  }
}
